export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_04.0b587ca6.jpg";